
const columnList: Array<column> = [
    {
        prop: "date",
        label: "预约时间段",
        width: 251,
    },
    {
        prop: "project_name",
        label: "预约服务分类",
        width: 251,
    },
    {
        prop: "people",
        label: "可预约次数",
        width: 251,
    },
];
import { defineComponent, ref, reactive, inject, onMounted, watch } from "vue";
import { Request } from "@/api/request";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "Appointment",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["运营管理", "预约设置"]);
        let tableData = ref([] as Array<any>),
            loading = ref(false),
            headClass = inject("headClass"),
            pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            selectGroup = ref({
                project_id: null,
                start_time: null,
                end_time: null,
            }),
            select = ref({
                time: [],
                project: [],
            }),
            setStatus = (id: number) => {
                Request.axiosInstance({
                    url: "adminapi/Preabout/upstatusPreabout",
                    data: {
                        id
                    },
                }).then(res => {
                    if(res.status == 200){
                        getTableData()
                    }
                });
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let data: any = {
                    ...selectGroup.value,
                    page: currentPage.value,
                    pagesize: pageSize.value,
                };
                Object.keys(data).forEach((key) => {
                    if (data[key] == null) {
                        delete data[key];
                    }
                });
                Request.axiosInstance({
                    url: "adminapi/Preabout/reservationSettingsList",
                    data,
                }).then((res: any) => {
                    loading.value = false;
                    tableData.value = res?.content?.list || [];
                    total.value = res?.content?.total || 0;
                });
            };

        onMounted(() => {
            getTableData();
            Request.axiosInstance({
                url: "adminapi/Preabout/dateTime",
            }).then((res: any) => {
                select.value.time = res?.content?.list || [];
            });
            Request.axiosInstance({
                url: "adminapi/ProjectType/list",
                data: {
                    status: 1,
                },
            }).then((res: any) => {
                select.value.project = res?.content?.list || [];
            });
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            setStatus,
            pageSize,
            currentPage,
            total,
            handleSizeChange,
            handleCurrentChange,
            selectGroup,
            select,
            getTableData,
        };
    },
});
